// This file contains the sagas used for async actions in our app.
// Sagas help us gather all our side effects (network requests in this case) in one place
import { take, call, put } from 'redux-saga/effects';
import Auth, { Token } from '@defi/core-auth';

import Url from '../utils/url'; 
import {
  PATH_DASHBOARD  
} from '../paths';
import {
  REQUEST_ERROR,
  PASSWORD_REQUEST,
  CLEAR_ERROR 
} from '../actions/constants';

/**
 * Effect to handle authorization
 * @param  {string} password               The username of the user
 * @param  {string} passwordConfirmation   The password of the user * @param  {object} options                Options
 */
export function * expiration({ currentPassword, newPassword }) {
  
  // We then try to log in the user
  try {
    let token = new Token();
    let currentProfile = token.getProfile();
    let username = currentProfile.UserName;
    let clientID = currentProfile.ClientId;
    let response = yield call(Auth.changePassword, username, newPassword, clientID, currentPassword);
    return response;   

  } catch (error) {

    // If we get an error we send Redux the appropiate action and return
    yield put({ type: REQUEST_ERROR, error: [error.message] });
    return false;
  }
}

/**
 * Expiration saga
 */
export function * expirationFlow() {
  // Because sagas are generators, doing `while (true)` doesn't block our program
  // Basically here we say "this saga is always listening for actions"
  while (true) {
    // And we're listening for `LOGIN_REQUEST` actions and destructuring its payload
    let request = yield take(PASSWORD_REQUEST);
    let { currentPassword, newPassword } = request.data;

    yield put({ type: CLEAR_ERROR });

    // check current and new pw don't match
    if(currentPassword !== newPassword){
      // Call the authorize for username/password
      let response = yield call(expiration, { currentPassword, newPassword });

      // We send Redux appropiate actions
      if (response.Errors)
      {
          yield put({ type: REQUEST_ERROR, error: response.Errors });
      }     
      else {

        let redirectUrl = Url.getRedirectParameter();
        if (redirectUrl !== null) {
          if (redirectUrl.substring(0, 1) !== '/') {
            redirectUrl = '/' + redirectUrl;
          }

          window.location = window.location.origin + redirectUrl;
        } else {
          window.location = PATH_DASHBOARD;
        }
      }
    }
    else {
        yield put({ type: REQUEST_ERROR, error: ['New Password Must Be Different Than Current Password'] });
    }

  }
}